import { baseApi as api } from "../baseApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getV2ProviderPatientsByPatientIdInvoices: build.query<
      GetV2ProviderPatientsByPatientIdInvoicesApiResponse,
      GetV2ProviderPatientsByPatientIdInvoicesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/patients/${queryArg.patientId}/invoices`,
        params: {
          limit: queryArg.limit,
          offset: queryArg.offset,
          status: queryArg.status,
        },
      }),
    }),
    getV2ProviderPatientsByPatientIdInvoicesAndInvoiceIdUrls: build.query<
      GetV2ProviderPatientsByPatientIdInvoicesAndInvoiceIdUrlsApiResponse,
      GetV2ProviderPatientsByPatientIdInvoicesAndInvoiceIdUrlsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/patients/${queryArg.patientId}/invoices/${queryArg.invoiceId}/urls`,
      }),
    }),
    getV2ProviderPatientsByPatientIdPaymentMethods: build.query<
      GetV2ProviderPatientsByPatientIdPaymentMethodsApiResponse,
      GetV2ProviderPatientsByPatientIdPaymentMethodsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/patients/${queryArg.patientId}/payment-methods`,
      }),
    }),
    postV2ProviderPatientsByPatientIdPaymentMethodsConfirm: build.mutation<
      PostV2ProviderPatientsByPatientIdPaymentMethodsConfirmApiResponse,
      PostV2ProviderPatientsByPatientIdPaymentMethodsConfirmApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/patients/${queryArg.patientId}/payment-methods/confirm`,
        method: "POST",
      }),
    }),
    postV2ProviderPatientsByPatientIdPaymentMethodsSetup: build.mutation<
      PostV2ProviderPatientsByPatientIdPaymentMethodsSetupApiResponse,
      PostV2ProviderPatientsByPatientIdPaymentMethodsSetupApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/patients/${queryArg.patientId}/payment-methods/setup`,
        method: "POST",
      }),
    }),
    getV2ProviderPatientsByPatientIdPaymentMethodsStatus: build.query<
      GetV2ProviderPatientsByPatientIdPaymentMethodsStatusApiResponse,
      GetV2ProviderPatientsByPatientIdPaymentMethodsStatusApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/patients/${queryArg.patientId}/payment-methods/status`,
      }),
    }),
    deleteV2ProviderPatientsByPatientIdPaymentMethodsAndPaymentMethodId:
      build.mutation<
        DeleteV2ProviderPatientsByPatientIdPaymentMethodsAndPaymentMethodIdApiResponse,
        DeleteV2ProviderPatientsByPatientIdPaymentMethodsAndPaymentMethodIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/provider/patients/${queryArg.patientId}/payment-methods/${queryArg.paymentMethodId}`,
          method: "DELETE",
        }),
      }),
    postV2ProviderPatientsByPatientIdPaymentMethodsAndPaymentMethodIdDefault:
      build.mutation<
        PostV2ProviderPatientsByPatientIdPaymentMethodsAndPaymentMethodIdDefaultApiResponse,
        PostV2ProviderPatientsByPatientIdPaymentMethodsAndPaymentMethodIdDefaultApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/provider/patients/${queryArg.patientId}/payment-methods/${queryArg.paymentMethodId}/default`,
          method: "POST",
        }),
      }),
    postV2ProviderPaymentRequests: build.mutation<
      PostV2ProviderPaymentRequestsApiResponse,
      PostV2ProviderPaymentRequestsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/payment-requests`,
        method: "POST",
        body: queryArg.sendPaymentRequestRequest,
      }),
    }),
    postV2ProviderStripeConnect: build.mutation<
      PostV2ProviderStripeConnectApiResponse,
      PostV2ProviderStripeConnectApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/stripe/connect`,
        method: "POST",
        body: queryArg.createStripeConnectRequest,
      }),
    }),
    getV2ProviderStripeConnectStatus: build.query<
      GetV2ProviderStripeConnectStatusApiResponse,
      GetV2ProviderStripeConnectStatusApiArg
    >({
      query: () => ({ url: `/v2/provider/stripe/connect/status` }),
    }),
    postV2ProviderStripeDashboardLink: build.mutation<
      PostV2ProviderStripeDashboardLinkApiResponse,
      PostV2ProviderStripeDashboardLinkApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/stripe/dashboard-link`,
        method: "POST",
        body: queryArg.createDashboardLinkRequest,
      }),
    }),
    getV2ProviderStripeInvoices: build.query<
      GetV2ProviderStripeInvoicesApiResponse,
      GetV2ProviderStripeInvoicesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/stripe/invoices`,
        params: {
          limit: queryArg.limit,
          starting_after: queryArg.startingAfter,
        },
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type GetV2ProviderPatientsByPatientIdInvoicesApiResponse =
  /** status 200 OK */ PatientInvoicesResponse;
export type GetV2ProviderPatientsByPatientIdInvoicesApiArg = {
  patientId: string;
  /** Number of invoices to return */
  limit?: number;
  /** Offset for pagination */
  offset?: number;
  /** Filter by invoice status (draft, open, paid, uncollectible, void) */
  status?: string | null;
};
export type GetV2ProviderPatientsByPatientIdInvoicesAndInvoiceIdUrlsApiResponse =
  /** status 200 OK */ InvoiceUrlsResponse;
export type GetV2ProviderPatientsByPatientIdInvoicesAndInvoiceIdUrlsApiArg = {
  patientId: string;
  invoiceId: string;
};
export type GetV2ProviderPatientsByPatientIdPaymentMethodsApiResponse =
  /** status 200 OK */ PatientPaymentMethodsResponse;
export type GetV2ProviderPatientsByPatientIdPaymentMethodsApiArg = {
  patientId: string;
};
export type PostV2ProviderPatientsByPatientIdPaymentMethodsConfirmApiResponse =
  /** status 200 OK */ ConfirmPaymentMethodResponse;
export type PostV2ProviderPatientsByPatientIdPaymentMethodsConfirmApiArg = {
  patientId: string;
};
export type PostV2ProviderPatientsByPatientIdPaymentMethodsSetupApiResponse =
  /** status 200 OK */ CreatePaymentSetupResponse;
export type PostV2ProviderPatientsByPatientIdPaymentMethodsSetupApiArg = {
  patientId: string;
};
export type GetV2ProviderPatientsByPatientIdPaymentMethodsStatusApiResponse =
  /** status 200 OK */ PaymentMethodStatusResponse;
export type GetV2ProviderPatientsByPatientIdPaymentMethodsStatusApiArg = {
  patientId: string;
};
export type DeleteV2ProviderPatientsByPatientIdPaymentMethodsAndPaymentMethodIdApiResponse =
  /** status 200 OK */ RemovePaymentMethodResponse;
export type DeleteV2ProviderPatientsByPatientIdPaymentMethodsAndPaymentMethodIdApiArg =
  {
    patientId: string;
    paymentMethodId: string;
  };
export type PostV2ProviderPatientsByPatientIdPaymentMethodsAndPaymentMethodIdDefaultApiResponse =
  /** status 200 OK */ SetDefaultPaymentMethodResponse;
export type PostV2ProviderPatientsByPatientIdPaymentMethodsAndPaymentMethodIdDefaultApiArg =
  {
    patientId: string;
    paymentMethodId: string;
  };
export type PostV2ProviderPaymentRequestsApiResponse =
  /** status 200 OK */ SendPaymentRequestResponse;
export type PostV2ProviderPaymentRequestsApiArg = {
  sendPaymentRequestRequest: SendPaymentRequestRequest;
};
export type PostV2ProviderStripeConnectApiResponse =
  /** status 200 OK */ CreateStripeConnectResponse;
export type PostV2ProviderStripeConnectApiArg = {
  createStripeConnectRequest: CreateStripeConnectRequest;
};
export type GetV2ProviderStripeConnectStatusApiResponse =
  /** status 200 OK */ GetStripeConnectStatusResponse;
export type GetV2ProviderStripeConnectStatusApiArg = void;
export type PostV2ProviderStripeDashboardLinkApiResponse =
  /** status 200 OK */ CreateDashboardLinkResponse;
export type PostV2ProviderStripeDashboardLinkApiArg = {
  createDashboardLinkRequest: CreateDashboardLinkRequest;
};
export type GetV2ProviderStripeInvoicesApiResponse =
  /** status 200 OK */ GetInvoicesResponse;
export type GetV2ProviderStripeInvoicesApiArg = {
  /** Number of invoices to return */
  limit?: number;
  /** Invoice ID to start after for pagination */
  startingAfter?: string | null;
};
export type InvoiceResponse = {
  /** Total amount in cents */
  amount_cents: number;
  /** Invoice creation timestamp */
  created_at: string;
  /** Invoice description */
  description?: string | null;
  /** Linked encounter ID */
  encounter_id?: string | null;
  /** Internal invoice UUID */
  id: string;
  /** When the invoice was paid */
  paid_at?: string | null;
  /** URL to view/pay the invoice */
  payment_url?: string | null;
  /** Direct PDF download URL */
  pdf_url?: string | null;
  /** Linked ERA remittance claim ID */
  remittance_claim_id?: string | null;
  /** Invoice status */
  status: string;
  /** Stripe invoice ID */
  stripe_invoice_id: string;
};
export type PatientInvoicesResponse = {
  /** List of invoices */
  invoices?: InvoiceResponse[];
};
export type ClientErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the client error */
  status?: number;
};
export type ValidationErrorElement = {
  ctx?: object;
  loc: string[];
  msg: string;
  type: string;
};
export type ValidationError = ValidationErrorElement[];
export type InvoiceUrlsResponse = {
  /** Stripe hosted invoice URL */
  payment_url?: string | null;
  /** Direct PDF download URL */
  pdf_url?: string | null;
};
export type PaymentMethodResponse = {
  /** Card brand (visa, mastercard, amex, etc.) */
  card_brand?: string | null;
  /** Card expiration month */
  card_exp_month?: number | null;
  /** Card expiration year */
  card_exp_year?: number | null;
  /** Last 4 digits of the card */
  card_last4?: string | null;
  /** Stripe payment method ID */
  id: string;
  /** Whether this is the default payment method */
  is_default?: boolean;
  /** Payment method type */
  type?: string;
};
export type PatientPaymentMethodsResponse = {
  /** List of saved payment methods */
  payment_methods?: PaymentMethodResponse[];
  /** Total number of payment methods */
  total?: number;
};
export type ServerErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the server error */
  status?: number;
};
export type ConfirmPaymentMethodResponse = {
  /** Whether the confirmation was successful */
  success: boolean;
};
export type CreatePaymentSetupResponse = {
  /** Client secret for Stripe Elements to confirm the SetupIntent */
  client_secret: string;
  /** Stripe SetupIntent ID */
  setup_intent_id: string;
};
export type PaymentMethodStatusResponse = {
  /** Whether patient has at least one saved payment method */
  has_payment_method: boolean;
};
export type RemovePaymentMethodResponse = {
  /** Whether the removal was successful */
  success: boolean;
};
export type SetDefaultPaymentMethodResponse = {
  /** Whether the default was set successfully */
  success: boolean;
};
export type SendPaymentRequestResponse = {
  /** Invoice amount in cents */
  amount_cents?: number | null;
  /** Internal invoice ID */
  invoice_id?: string | null;
  /** Invoice status: paid, open, draft */
  invoice_status?: string | null;
  /** Result message */
  message: string;
  /** Hosted payment link (useful when auto-charge fails) */
  payment_url?: string | null;
  /** SMS delivery status if applicable */
  sms_status?: string | null;
  /** Stripe invoice ID */
  stripe_invoice_id?: string | null;
  /** Whether the payment request was sent successfully */
  success: boolean;
};
export type SendPaymentRequestRequest = {
  /** Payment amount in dollars (e.g., '150.00') */
  amount: string;
  /** Optional appointment ID this payment is for */
  appointment_id?: string | null;
  /** Charge line IDs this invoice covers. Enables multi-encounter allocation when payment arrives. */
  charge_line_ids?: string[] | null;
  /** Payment due date in YYYY-MM-DD format */
  due_date?: string | null;
  /** Optional encounter ID this payment is for */
  encounter_id?: string | null;
  /** Patient mobile phone for SMS delivery. If provided, updates the patient record. Falls back to patient's existing mobile_phone. */
  mobile_phone?: string | null;
  /** The patient's ID */
  patient_id: string;
  /** Stripe payment method ID to charge (uses patient's default if not provided) */
  payment_method_id?: string | null;
  /** Reason for the payment request */
  reason: string;
  /** Send SMS notification with payment link. Set False for silent card charges. */
  send_notification?: boolean;
  /** Source of the payment request (e.g., 'api', 'action') */
  source?: string | null;
  /** Statement run ID if this invoice was triggered from the statement queue. */
  statement_run_id?: string | null;
};
export type CreateStripeConnectResponse = {
  message?: string;
  onboarding_url: string;
  stripe_account_id: string;
};
export type CreateStripeConnectRequest = {
  refresh_url: string;
  return_url: string;
};
export type GetStripeConnectStatusResponse = {
  charges_enabled?: boolean;
  country?: string | null;
  default_currency?: string | null;
  details_submitted?: boolean;
  has_account?: boolean;
  message: string;
  payouts_enabled?: boolean;
  stripe_account_id?: string | null;
};
export type CreateDashboardLinkResponse = {
  dashboard_url: string;
  message?: string;
};
export type CreateDashboardLinkRequest = {};
export type InvoiceResponse2 = {
  /** Amount due in cents */
  amount_due: number;
  /** Amount paid in cents */
  amount_paid: number;
  created: string;
  customer_email?: string | null;
  customer_name?: string | null;
  due_date?: string | null;
  hosted_invoice_url?: string | null;
  id: string;
  number?: string | null;
  paid_at?: string | null;
  pdf?: string | null;
  status: string;
};
export type GetInvoicesResponse = {
  has_more: boolean;
  invoices: InvoiceResponse2[];
  message?: string;
  /** Use as starting_after for next page */
  next_cursor?: string | null;
};
